
export default {
  name: "Information",
};
